<template>
  <span class="cf-consent-terms">
    <template v-if="consentSegments.length">
      <template
        v-for="(segment, index) in consentSegments"
        :key="index"
      >
        <button
          v-if="segment.modalName"
          class="cf-link cf-link--brand-secondary cf-link--heavy"
          type="button"
          @click="segmentClickHandler(segment)"
        >
          {{ segment.text }}
        </button>

        <template v-else>{{ segment.text }}</template>
      </template>
    </template>

    <slot v-else />
  </span>
</template>


<script>
  import { mapGetters } from 'vuex';

  import { splitLegalPhrases } from '@/helpers/legal-links';


  export default {
    name: 'CfConsentTerms',

    props: {
      content: {
        type: String,
        default: ''
      }
    },

    computed: {
      ...mapGetters('content', ['generalNotice']),

      consentSegments() {
        return splitLegalPhrases(this.content);
      }
    },

    methods: {
      segmentClickHandler({ modalName }) {
        // A merchant can name the general notice without filling the section in; an inert phrase beats an empty modal.
        if (modalName === 'generalNotice' && !this.generalNotice.isAvailable) return;

        this.$openModal(modalName);
      }
    }
  };
</script>
